<template>
  <div class="me-badge">
    <slot></slot>
    <div class="me-badge__dot" v-if="showBadge" :class="classes">{{ formatContent }}</div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: [Number, String],
      default: '',
    },
    variant: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'danger'].includes(value),
    },
    position: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom', 'center'].includes(value),
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    overlap: Boolean,
  },

  computed: {
    formatContent() {
      return +this.content > 99 ? '99+' : this.content;
    },

    sizeClasses() {
      const contentLength = this.content.toString().length;

      if (contentLength === 1) {
        return 'me-badge__dot--single-char';
      }

      if (contentLength >= 2) {
        return 'me-badge__dot--multiple-char';
      }

      return 'me-badge__dot--empty';
    },

    variantClasses() {
      return `me-badge__dot--${this.variant}`;
    },

    positionClasses() {
      return `me-badge__dot--${this.position}${(this.overlap) ? '-overlap' : ''}`;
    },

    classes() {
      return [this.sizeClasses, this.variantClasses, this.positionClasses];
    }
  }
}
</script>

<style lang="stylus" scoped>
.me-badge
  position relative

  &__dot
    position absolute
    color white
    font-size 0.625rem
    line-height 1.5
    text-align center
    border-radius 9999px

    &--empty
      width 0.5rem
      height 0.5rem

    &--single-char
      width 1rem
      height 1rem

    &--multiple-char
      width min-content
      height min-content
      line-height 1.25
      padding 0.125rem 0.25rem

    &--info
      background-color #3598dc

    &--danger
      background-color #e7505a

    &--top
      left 100%
      bottom 100%

    &--top-overlap
      top 0
      right 0
      transform translate(50%, -50%)

    &--bottom
      top 100%
      left 100%

    &--bottom-overlap
      bottom 0
      right 0
      transform translate(50%, 50%)

    &--center
      top 50%
      left 100%
      transform translate(50%, -50%)

    &--center-overlap
      top 50%
      left 100%
      transform translateY(-50%)
</style>
